<template>
    <transition name="dialog">
        <div class="dml-dialog">
            <div class="dml-dialog__container">
                <div class="dml-dialog__title" v-if="title">
                    {{title}}
                </div>
                <div class="dml-dialog__content">
                    <slot></slot>
                </div>
                <div class="dml-dialog__actions">
                    <button v-on:click="$emit('confirm')" class="btn btn--primary" data-t="7.9">
                        {{actionConfirmLabel}}
                    </button>
                    <button v-if="showCancelButton" v-on:click="$emit('cancel')" class="btn">
                        {{actionCancelLabel}}
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>

    export default {
        name: 'dm-dialog',
        props: {
            title: {
                type: String
            },
            showCancelButton: {
                type: Boolean,
                default: true
            },
            actionConfirmLabel: {
                type: String,
                default: 'Tak'
            },
            actionCancelLabel: {
                type: String,
                default: 'Anuluj'
            }
        }
    };
</script>
